// extracted by mini-css-extract-plugin
var _1 = "chat-layout__md3Zc";
var _2 = "chat-layout__content__AG5YY";
var _3 = "chat-layout__footer__TniMJ";
var _4 = "chat-layout__header__iWvQO";
var _5 = "chat-layout__sub-header__PQ3nG";
export { _1 as "chatLayout", _2 as "chatLayoutContent", _3 as "chatLayoutFooter", _4 as "chatLayoutHeader", _5 as "chatLayoutSubHeader" }
